import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getSkillList } from 'components/skill/SkillAPI';
import { setSkillList, setSkillDashboardSkillList } from 'store/slice/ManufSlice';
import SkillDashboard from '../SkillDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function SkillPageImpl() {
    const dispatch = useDispatch();
    const { skillList} = useSelector((state)=>state.manufslice);
    
    const getSkillListSuccess = (list) =>{dispatch(setSkillList(list));}
    useEffect(() => {
        getSkillList(()=>{}, getSkillListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setSkillDashboardSkillList( skillList));
    },[ skillList])

    return (
        < SkillDashboard />
    )

}